import { call, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import config from '../../config';
import request from 'superagent';

export function* fetch_logic_occupancy() {
    yield* takeEvery("LOGIC/OCCUPANCY/FETCH", function* (action) {
        try {
            const result = yield call(({ IdProperty, Flag }) => {
                return request.post(`${config.apiEndpoint}/api/v4/logic/occupancy/summary/${IdProperty}`)
                    .send({ Flag })
                    .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { occupancy_summary } = result;
                yield put({ type: 'OCCUPANCY/SUMMARY/SET', occupancy_summary });
            } else {
                yield put({
                    type: 'OCCUPANCY/SUMMARY/FETCH_FAILED',
                    result
                });
            }
        } catch (e) {
            yield put({
                type: 'OCCUPANCY/SUMMARY/FETCH_FAILED',
                e
            });
        }
    });
}

export function* fetch_logic_occupancy_graph() {
    yield* takeEvery("LOGIC/OCCUPANCY_GRAPH/FETCH", function* (action) {
        try {
            const result = yield call(({ IdProperty, Flag }) => {
                return request.post(`${config.apiEndpoint}/api/v4/logic/occupancy/graph/${IdProperty}`)
                    .send({ Flag })
                    .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                yield put({ type: 'OCCUPANCY_GRAPH/SET', data: result.data });
            }
        } catch (e) {
            console.error('OCCUPANCY_GRAPH/FETCH_FAILED', e);
        }
    });
}

export function* fetch_conversion_rates() {
    yield* takeEvery("LOGIC/CONVERSION_RATES/FETCH", function* (action) {
        try {
            const result = yield call(() => {
                return request.get(`${config.apiEndpoint}/api/v4/logic/conversion_rates`)
                    .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { usd, eur } = result;
                localStorage?.setItem('legendbeds.conversion_rates', JSON.stringify(result)); // put here the auth token ?
                yield put({ type: 'LOGIC/CONVERSION_RATES/SET' });
            } else {
                yield put({
                    type: 'LOGIC/CONVERSION_RATES/FETCH_FAILED',
                    result
                });
            }
        } catch (e) {
            yield put({
                type: 'LOGIC/CONVERSION_RATES/FETCH_FAILED',
                e
            });
        }
    });
}
